// resetPasswordErrorHandler.js

export function validateResetPasswordInput(email, code, newPassword) {
  if (!code && !newPassword) {
    return "Please enter reset code and new password.";
  }
  if (!code) {
    return "Please enter the reset code.";
  }
  if (!newPassword) {
    return "Please enter your new password.";
  }

  const passwordRegex =
    /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*_\-+={[}\]|\\:;"'<,>.?/]).{5,}$/;

  if (!passwordRegex.test(newPassword)) {
    return "Password must be at least 5 characters long and include at least one uppercase letter, one number, and one special symbol.";
  }

  return null;
}

export function parseResetPasswordError(error) {
  const status = error?.status ?? error?.response?.status;

  if (!status) {
    return "An unexpected error occurred. Please try again later.";
  }

  switch (status) {
    case 404:
      return "Invalid reset code.";
    case 400:
      return "Invalid request. Please check your input.";
    case 500:
      return "Server error. Please try again later.";
    case 502:
    case 503:
    case 504:
      return "Service is temporarily unavailable. Please wait and try again.";
    default:
      return "An error occurred. Please try again.";
  }
}
